import { apiPost } from "./http";

export type PlatformTenantWeappQrcodeResult = {
  url: string;
  page: string;
  scene: string;
  envVersion: string;
};

export async function postPlatformTenantWeappUnlimitedQrcode(
  tenantLegacyId: string,
  body?: { page?: string; envVersion?: "release" | "trial" | "develop"; width?: number; isHyaline?: boolean },
) {
  const tid = tenantLegacyId.trim();
  return apiPost<PlatformTenantWeappQrcodeResult>(
    `/api/platform/tenants/${encodeURIComponent(tid)}/mini-program/unlimited-qrcode`,
    {
      page: body?.page || "pages/landing/index",
      envVersion: body?.envVersion || "release",
      width: body?.width ?? 430,
      isHyaline: body?.isHyaline ?? false,
    },
  );
}
